export const playAudioNotification = (filename) => {
  try {
    const audio = new Audio(`${process.env.PUBLIC_URL}/audio/${filename}`);
    audio.play().catch((error) =>
      console.log(`Error playing ${filename}:`, error)
    );
  } catch (error) {
    console.log(`Error creating audio notification for ${filename}:`, error);
  }
};
